
import { User } from "lucide-react";
import { getDatabaseKey, getApiBaseUrl } from "./configHelper";

const api = {
  get: async (endpoint, params = {}) => {
    const baseUrl = await getApiBaseUrl();
    const databaseKey = await getDatabaseKey();
    const url = new URL(`${baseUrl}/${endpoint}`);

    // Add databaseKey to params
    params.databaseKey = databaseKey;

    Object.keys(params).forEach((key) => url.searchParams.append(key, params[key]));

    const response = await fetch(url.toString());
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    const json = await response.json();
    const dataKey = Object.keys(json)[0];
    return json[dataKey];
  },

 post: async (endpoint, body = {}, extraParams = {}) => {
    const baseUrl = await getApiBaseUrl();
    const databaseKey = await getDatabaseKey();

    const url = new URL(`${baseUrl}/${endpoint}`);
    // Append databaseKey to query string
    url.searchParams.append("databaseKey", databaseKey);

    // Add any extra query params if needed
    Object.keys(extraParams).forEach((key) =>
      url.searchParams.append(key, extraParams[key])
    );

    const response = await fetch(url.toString(), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });

    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return response.json();
  },

//   // --- Old APIs (Orders, Customers, Stock, etc.) ---
//  checkLogin: (UsrName, UsrPwd) =>
//     api.post("CheckLogin", {
//       UsrName,
//       UsrPwd,
//       SessionId: "9944010155",
//       IPAddress: "12345",
//       ComId: "ComId",
//       AppKey: "AppKey",
//     }),



  checkLogin: (UsrName, UsrPwd) =>
  api.post("CheckLogin", {
    UsrName,
    UsrPwd,
    SessionId: '9944010155',
    IPAddress: '12345',
    ComId: 'ComId',
    AppKey: 'AppKey',
  }),


  // --- Login ---
  CompanyDetails: (user) => api.get("CompanyDetailsAPI", { user }),

  // --- Orders ---
  getSalesPoStatement: (userName) => api.get("GetSalesPoStatementAPI", { userName }),
  getSimplePOList: (userName) => api.get("GetSimplePOListAPI", { userName }),
  createOrder: (orderData) => api.post("MobCreateorderlist", orderData),


  getOrderForEdit: (Poid) => api.get("EditPoOrderAPI", { Poid }),
  updateOrderDetails: (orderDetails) => api.post("MobupdateorderlistAPI", orderDetails),
  saveOrderItem: (itemData) => api.post("Saveorder", itemData),
  deleteOrderItem: (ordId, Itemid) => api.get("Mobdeleteorderitem", { ordId, Itemid }),
  getSelectedOrder: (ordId) => api.get("MobGetSelectedOrder", { ordId }),
  saveMakeReceipt: (receiptData) => api.post("SaveMakeReceiptAPI", receiptData),
  MobGetfinalizeOrder: (ordId) => api.get("MobGetfinalizeOrder", { ordId }),
  OrderProcedureAPI: (Ordid, Vid, Username) => api.get("OrderProcedureAPI", { Ordid, Vid, Username }),
  GetDataReport: (User) => api.get("GetDataReportAPI", User),
  SflowersReports: (Vid, ReportType, FromDate, Todate, UserName) => api.get("SflowersReportsAPI", Vid, ReportType, FromDate, Todate, UserName),
  GetHtmlPackingSlip: (PoId) => api.get("GetHtmlPackingSlipAPI", { PoId }),
  MobSaveOrderDetailsRevAPI: (itemData) => api.post("MobSaveOrderDetailsRevAPI", itemData),

  GetHtmlPoQuotationAPI: (PoId) => api.get("GetHtmlPoQuotationAPIRev", { PoId }),

  // --- Purchase ---
  getpurSimplePOList: (userName) => api.get("GetPurSimplePOListAPI", { userName }),
  getSuppilerListWithBalance: (user) => api.get("SupplierListWithBalance", { user }),
  purcreateOrder: (orderData) => api.post("MobPurCreateorderlist", orderData),
  getpurSelectedOrder: (ordId) => api.get("MobGetPurSelectedOrder", { ordId }),
  getpurOrderForEdit: (Poid) => api.get("EditPurPoOrderAPI", { Poid }),
  savepurOrderItem: (itemData) => api.post("SavePurorder", itemData),
  deletepurOrderItem: (ordId, Itemid) => api.get("MobdeletePurorderitem", { ordId, Itemid }),
  updatepurOrderDetails: (orderDetails) => api.post("MobPurupdateorderlistAPI", orderDetails),
  MobGetpurfinalizeOrder: (ordId) => api.get("MobGetPurfinalizeOrder", { ordId }),

  // --- Stock ---
  getsimplestockList: (userName) => api.get("GetSimpleStockListAPI", { userName }),
  getstockTypeList: (userName) => api.get("GetStockTypeListAPI", { userName }),

  StkAdjGodownList: (StkType, GdId) => api.get("StkAdjGodownListAPI", { StkType, GdId }),

  //  CreateStocklist: (orderData) => api.post("MobCreateStocklist", orderData),
  CreateStocklist: (data) => api.post("MobCreateStocklist", data),
  getselectedStock: (ordId) => api.get("MobGetSelectedStockAPI", { ordId }),
  mobdeleteStockitem: (ordId, Itemid) => api.get("mobdeleteStockitemAPI", { ordId, Itemid }),
  // mobdeleteStockitem: (ordId, Itemid) => api.get("mobdeleteStockitemAPI", { params: { ordId, Itemid } }),
  editpoStock: (Poid) => api.get("EditPoStockAPI", { Poid }),
  saveStock: (itemData) => api.post("SaveStockAPI", itemData),
  updateStkList: (orderDetails) => api.post("MobupdateStklistAPI", orderDetails),
  StockAdjustment: (Poid, UserName) => api.get("StockAdjustmentAPI", { Poid, UserName }),

  // --- Customers ---
  getCustomerListWithBalance: (user) => api.get("CustomerListWithBalance", { user }),
  getCustomerForEdit: (vid) => api.get("EditVendorOrimShort", { vid }),
  saveCustomer: (customerData) => api.post("DMLVendorOrimRevAPI", customerData),
  savePayment: (paymentData) => api.post("DMLPaymentOrimShortAPI", paymentData),
  ItemRateUpdate: (RateUpdate) => api.post("UpdateItemRateAPI", RateUpdate),

  // --- Supplier ---
  getSupplierListWithBalance: (user) => api.get("SupplierListWithBalance", { user }),
  getSupplierForEdit: (vid) => api.get("EditVendorOrimShort", { vid }),
  saveSupplier: (supplierData) => api.post("DMLSupplierOrimShortAPI", supplierData),

  // --- Items ---
  getItemList: (User) => api.get("GetItemList", { User }),
  SaveItemList: (SaveItem) => api.post("SaveItemList", SaveItem),

  OrderVsDelivery: (userName) => api.get("OrderVsDeliveryAPI", { userName }),


  // --- ChangePassword ---
  getMobileUser: (Usrname) => api.get("getMobileUserAPI", { Usrname }),
  UpdateMobUserPassword: (ChangePassword) => api.post("UpdateMobUserPasswordAPI", ChangePassword),

  // --- Counter ---
  UserGodownLogin: (GodownLogin) => api.post("UserGodownLoginAPI", GodownLogin),


  OpenningBalanceList: (user) => api.get("OpenningBalanceListAPI", { user }),
  GetPartylist: (user) => api.get("GetPartylistAPI", { user }),
  SaveOpenningBalance: (SaveOpenningBalance) => api.post("SaveOpenningBalanceAPI", SaveOpenningBalance),
  Edit_OpenningBalance: (CPId) => api.get("Edit_OpenningBalanceAPI", { CPId }),

  StockReport: (user) => api.get("StockReportAPI", { user }),
  ORderVsStock_API: (user) => api.get("ORderVsStock_API", { user }),

  Gettype: (User) => api.get("GettypeAPI", { User }),
  SalesPurchaseMIS: (TxnType, userName, FromDate, ToDate) => api.get("SalesPurchaseMISAPI", { TxnType, userName, FromDate, ToDate }),
  GetDailySalesStatement: (FromDate, ToDate) => api.get("GetDailySalesStatement", { FromDate, ToDate }),
  GetDailySupplierSalesStatement: (FromDate, ToDate) => api.get("GetDailySupplierSalesStatement", { FromDate, ToDate }),

  StockQtyItemWise: (Itemid) => api.get("StockQtyItemWiseAPI", { Itemid }),


  UpdateOrderPackStatusAPI: (Poid, PackingStatus, Usrname) => api.get("UpdateOrderPackStatusAPI", { Poid, PackingStatus, Usrname }),
  AllotOrderToPersonAPI: (Poid, JobTo, Usrname) => api.get("AllotOrderToPersonAPI", { Poid, JobTo, Usrname }),
  UpdateOrderDeliveryStatusAPI: (PoId, DvlNote, Usrname) => api.get("UpdateOrderDeliveryStatusAPI", { PoId, DvlNote, Usrname }),
  GetPoOrderItemlistAPI: (Poid, User) => api.get("GetPoOrderItemlistAPI", { Poid, User }),
  GetRmpUserAPI: (User) => api.get("GetRmpUserAPI", { User }),
  EditOrderDeliveryStatus: (Poid) => api.get("EditOrderDeliveryStatus", { Poid }),

  getpartydetailsAPI: (UserName) =>
    api.get(`GetpartydetailsAPI?UserName=${UserName}`),


  EmployeeList: (UserName) => api.get("EmployeeListAPI", { UserName }),
  SaveEmployee: (SaveEmployee) => api.post("SaveEmployeeAPI", SaveEmployee),
  EditEmployee: (PrimeIdStr) => api.get("EditEmployeeAPI", { PrimeIdStr }),

  EditItemList: (Itemid) => api.get("EditItemList", { Itemid }),

  getpartydetailsAPI: (UserName) => api.get(`GetpartydetailsAPI?UserName=${UserName}`),
  getItemTaxAPI: (UserName) => api.get("GetItemTaxAPI", { UserName }),

  getFocusRightsAPI: (UserName,Module) =>api.get("GetFocusRightsAPI", { UserName,Module }),

  GetPoOrderItemdeliverylistAPI: (Poid, User) => api.get("GetPoOrderItemdeliverylistAPI", { Poid, User }),
  GetSimplePOListdeliveryAPI: (UserName) => api.get("GetSimplePOListdeliveryAPI", { UserName }),
  GetRmpUserDeliveryAPI: (User) => api.get("GetRmpUserDeliveryAPI", { User }),
  GetHtmldeliveryPackingSlip: (PoId) => api.get("GetHtmldeliveryPackingSlip", { PoId }),
  EditOrderDeliveryStatus2: (Poid) => api.get("EditOrderDeliveryStatus2", { Poid }),
  UpdateOrderDeliveryPackStatus: (Poid, PackingStatus, Usrname) => api.get("UpdateOrderDeliveryPackStatus", { Poid, PackingStatus, Usrname }),
  UpdateOrderDeliveryStatus2API: (PoId, DvlNote, Usrname) => api.get("UpdateOrderDeliveryStatus2API", { PoId, DvlNote, Usrname }),
  DeliveryAllotOrderToPerson: (Poid, JobTo, Usrname) => api.get("DeliveryAllotOrderToPerson", { Poid, JobTo, Usrname }),




  GetPurTaxSimplePOListAPI: (userName) => api.get("GetPurTaxSimplePOListAPI", { userName }),
  getSupplierListWithBalanceTax: (user) => api.get("SupplierListWithBalanceTax", { user }),
  createPurchaseOrder: (orderData) => api.post("MobpurTaxCreateorderlist", orderData),
  getSelectedPurchaseOrder: (ordId) => api.get("MobpurTaxGetSelectedOrder", { ordId }),
  getPurchaseOrderForEdit: (Poid) => api.get("EditPurTaxPoOrderAPI", { Poid }),
  SelectedPurchaseordertax: (ordId) => api.get("MobpurTaxGetSelectedOrder", { ordId }),
  MobSaveOrderDetailsPurtaxRev: (itemData) => api.post("MobSaveOrderDetailsPurtaxRev", itemData),
  mobdeleteorderitemPurTax: (ordId, Itemid) => api.get("mobdeleteorderitemPurTax", { ordId, Itemid }),
  updatePurchaseOrderDetails: (orderDetails) => api.post("MobPurTaxupdateorderlist", orderDetails),
  MobGetpurfinalizeOrder: (ordId) => api.get("MobGetPurfinalizeOrder", { ordId }),
  MobpurTaxGetSelectedOrder: (ordId) => api.get("MobpurTaxGetSelectedOrder", { ordId }),


  ExpenseList: (UserName) => api.get("ExpenseListAPI", { UserName }),
  GetExpenseVal: (UserName) => api.get("GetExpenseValAPI", { UserName }),
  EditExpenseList: (EntId) => api.get("EditExpenseListAPI", { EntId }),
  SaveExpenseAPI: (SaveExpense) => api.post("SaveExpenseAPI", SaveExpense),

      GetCancelDocTypeAPI: (User) => api.get("GetCancelDocTypeAPI", { User }),
    GetCancelDocNoAPI: (DocType, User) => api.get("GetCancelDocNoAPI", { DocType, User }),
    CancelDetailsAPI: (PrimeId, DocType, User) => api.get("CancelDetailsAPI", { PrimeId, DocType, User }),
    AllDocDeleteAPI: (Canceldata) => api.post("AllDocDeleteAPI",  Canceldata ),


    CancelListAPI: (User) => api.get("CancelListAPI", { User }),
     RmpMenuListAPI: (User) => api.get("RmpMenuListAPI", { User }),
    GetinvAdjustment: (User) => api.get("GetinvAdjustment", { User }),
    GetInvAdjuestDocAPI: (User) => api.get("GetInvAdjuestDocAPI", { User }),
    GetVendorSalesAdjustment: (FromDate, ToDate, Vid, Vtype) =>
      api.get("GetVendorSalesAdjustment", { FromDate, ToDate, Vid, Vtype }),
    EditinvAdjustment: (User, PrimeId) => api.get("EditinvAdjustment", { User, PrimeId }),
    SaveInvAdjAmount: (payload) => api.post("SaveInvAdjAmountAPI", payload),



  getpartydetailsAPI: (UserName) => api.get(`GetpartydetailsAPI?UserName=${UserName}`),
  getItemTaxAPI: (UserName) => api.get("GetItemTaxAPI", { UserName }),
  getSimplePOListTaxAPI: (userName) => api.get("GetSimplePOListTaxAPI", { userName }),
  getSimplePOListTaxAPIDateWise: (UserName, FromDate, ToDate) =>
    api.get("GetSimplePOListTaxAPIDateWise", { UserName, FromDate, ToDate }),
  getCustomerListWithBalanceTax: (user) => api.get("CustomerListWithBalanceTax", { user }),
  getCustomerListWithBalanceTaxRev: (user) => api.get("CustomerListWithBalanceTaxRev", { user }),
  createSalesOrder: (orderData) => api.post("MobCreateorderlistTax", orderData),
  createSalesOrderRev: (orderData) => api.post("MobCreateorderlistTaxRev", orderData),
  getSelectedSalesOrder: (ordId) => api.get("MobGetSelectedOrderTax", { ordId }),
  StockQtyItemWiseTaxAPI: (Itemid) => api.get("StockQtyItemWiseTaxAPI", { Itemid }),
  saveorderTaxItem: (itemData) => api.post("SaveorderTax", itemData),
  getSalesOrderForEdit: (Poid) => api.get("EditPoOrderTaxRev", { Poid }),
  updateSalesOrderDetails: (orderDetails) => api.post("MobupdateorderlistTaxRevAPI", orderDetails),
  deleteSalesOrderItem: (ordId, Itemid) => api.get("mobdeleteorderitemTax", { ordId, Itemid }),
  MobSaveOrderDetailsRevTaxAPI: (itemData) => api.post("MobSaveOrderDetailsRevTaxAPI", itemData),
  GetPoOrderItemlistTaxAPI: (Poid, User) => api.get("GetPoOrderItemlistTaxAPI", { Poid, User }),
  EditOrderDeliveryStatusTax: (Poid) => api.get("EditOrderDeliveryStatusTax", { Poid }),
  UpdateOrderDeliveryStatusTax: (PoId, DvlNote, Usrname) => api.get("UpdateOrderDeliveryStatusTax", { PoId, DvlNote, Usrname }),
  AllotOrderToPersonTax: (Poid, JobTo, Usrname) => api.get("AllotOrderToPersonTax", { Poid, JobTo, Usrname }),
  UpdateOrderPackStatustax: (Poid, PackingStatus, Usrname) => api.get("UpdateOrderPackStatustax", { Poid, PackingStatus, Usrname }),


  BankDetail: (UserName) => api.get("BankDetailAPI", { UserName }),
  EditBank: (Bid) => api.get("EditBankOrimtblAPIRev", { Bid }),
  SaveBankOrimtbl: (SaveBank) => api.post("SaveBankOrimtblAPIRev", SaveBank),
  GetBankPaymentModeListRev: (UserName) => api.get("GetBankPaymentModeListRev", { UserName }),

GetPaymentlistApi: (UserName) => api.get("GetPaymentlistApi", { UserName }),
GetPaymentApiDateWise: (UserName, FromDate, ToDate) => api.get("GetPaymentApiDateWise", { UserName, FromDate, ToDate }),
GetInvtype: (username) => api.get("GetInvtype", { username }),
GetInvPaymentReceipt: (InvType, FromDate, ToDate) => api.get("GetInvPaymentReceipt", { InvType, FromDate, ToDate }),
CustomerListWithBalance: (user) => api.get("CustomerListWithBalance", { user }),
EditPaymentAPI: (Vrid) => api.get("EditPaymentAPI", { Vrid }),
SavePayment: (Savepayment) => api.post("SavePaymentRev",  Savepayment ),



 OnlineGetPOItemAPI: (Poid) => api.get("OnlineGetPOItemAPI", { Poid }),

  OnlineSimplePOAPI: (UserName) => api.get("OnlineSimplePOAPI", { UserName }),

  OnlinePoHead2SimplepoAPI: (payload) => api.post("OnlinePoHead2SimplepoAPI", payload),


GetSupplierPaymentlistApi: (UserName) => api.get("GetSupplierPaymentlistApi", { UserName }),
SupplierListWithBalance: (user) => api.get("SupplierListWithBalance", { user }),
Edit_SupplierPaymentApi: (Vrid) => api.get("Edit_SupplierPaymentApi", { Vrid }),
SavesupplierPayment: (Savepayment) => api.post("SavesupplierPaymentRev",  Savepayment ),

GetAccountledger: (user) => api.get("GetAccountledger", { user }),
AccountLedgercuswiseAPI: (Vtype, Vid, FromDate, ToDate, Sessid, Usrname,  Rptformat) => 
  api.get("AccountLedgercuswiseAPI", { Vtype, Vid, FromDate, ToDate, Sessid, Usrname, Rptformat }),

  GetHtmlReceiptAPI: (PoId) => api.get("GetHtmlReceiptAPI", { Vrid }),
  // --- New APIs (GlTxn / Party) ---
  getTxnTypes: (user) => api.get("GetQlTxnTypeAPI", { User: user }),
  getTxnSubTypes: (docTypeName) => api.get("GetQlTxnSubTypeAPI", { DocTypeName: docTypeName }),
  getPartyTypeGl: (GlId, user) => api.get("GetPartyTypeGlAPI", { Glid: GlId, User: user }),
  saveGlTxn: (payload) => api.post("GlTxnSaveAPI", payload),
  postGlPartyDetailsSave: (payload) => api.post("GlPartyDetailsSaveAPI", payload),
  getTransportDetailsAPI: (user) => api.get("GetGlTxnTransportDetailsAPI", { User: user }),
};

export default api;


